import { useState } from "react";

import api from "./api";
import { StoreProfile } from "../models";
import { useCallback } from "react";

export const useStoreProfile = () => {
  const [page, setPage] = useState<number>(1);
  const [getLoading, setGetLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  
  const [storeProfiles, setStoreProfiles] = useState<StoreProfile[]>([]);
  const [storeLoaded, setStoreLoaded] = useState<boolean>(false);

  const getStoreProfiles = useCallback((): Promise<StoreProfile[]> => {
    setLoading(true);
    return api
      .get<StoreProfile[]>("v1/store/")
      .then((response) => {
        setStoreProfiles(response.data);
        setLoading(false);
        setStoreLoaded(true);
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch store profiles:", error);
        setLoading(false);
        return Promise.reject(error);
      });
  }, []);

  const getStoreProfile = useCallback((id: string): Promise<StoreProfile> => {
    if (!id) {
      return Promise.reject(new Error("Store profile ID is required"));
    }
    
    setGetLoading(true);
    return api
      .get<StoreProfile>(`/v1/store/${id}`)
      .then((response) => {
        setGetLoading(false);
        return response.data;
      })
      .catch((error) => {
        setGetLoading(false);
        return Promise.reject(error);
      });
  }, []);

  const addStoreProfile = useCallback(
    async (newStoreProfile: StoreProfile) => {
      const response = await api.post("/v1/store/", newStoreProfile);
      return response.data;
    },
    []
  );

  const updateStoreProfile = useCallback((storeProfile: StoreProfile) => {
    return api.put(`/v1/store/${storeProfile.id}`, storeProfile);
  }, []);

  // const storeProfileStats = useCallback(() => {
  //   return api
  //     .get<StoreProfileStats>(`/v1/store/stats`)
  //     .then((response) => {
  //       return response.data;
  //     });
  // }, []);

  // const storeProfileStatsDetail = useCallback((category: string) => {
  //   return api
  //     .get(`/v1/store/stats/details`, { params: { category } })
  //     .then((response) => {
  //       return response.data;
  //     });
  // }, []);

  return {
    page,
    setPage,
    loading,
    getLoading,
    storeLoaded,
    storeProfiles,
    getStoreProfiles,
    getStoreProfile,
    addStoreProfile,
    updateStoreProfile,
    // storeProfileStats,
    // storeProfileStatsDetail,
  };
};
